<template>
  <div class="home">
    <div class="swiper">
      <!-- <img src="../img/index_1.png" alt="" /> -->
      <div class="htop">
        <div class="toptexts">
          <div class="">数智方舟——专业的数智方案服务平台</div>
          <div class="weclome">
          提供数智化解决方案，共享数智化资源
          </div>
        </div>
      </div>
    </div>

    <!-- 在做什么 -->
    <div class="theme pa-b-40">
      <div class="">
        <div class="title ma-t-40">数智方舟服务内容</div>
        <div class="b-blue ma-t-10"></div>
      </div>
      <div class="c-333 t-center ma-tb-20">
        囊括多个行业的解决方案，以多种形式展示具体内容，搭载试用体系深刻理解数智解决方案，拓阔数智思路。
      </div>
      <div
        style="width: 1200px"
        class="flex f-between t-center"
      >
        <div class="">
          <img src="../img/home/s11.png" />
          <div class="ma-t-30">在线课程</div>
          <div class="c-555 ma-t-20 width80 ma-lr-auto fon-14">
          直播、录播和图文多种形式展示数智方案
          </div>
        </div>
        <div class="">
          <img src="../img/home/s12.png" />
          <div class="ma-t-30">行业报告</div>
          <div class="c-555 ma-t-20  width80 ma-lr-auto fon-14">
           共享行业报告，深度剖析行业关键词，共同挖掘数智潜力
          </div>
        </div>
        <div class="">
          <img src="../img/home/s13.png" />
          <div class="ma-t-30">在线试用</div>
          <div class="c-555 ma-t-20  width80 ma-lr-auto fon-14">
           通过系统引导，了解数智系统功能，免费在线试用
          </div>
        </div>
      </div>
    </div>

    <div class="theme pa-b-40 bg-e ">
      <div class="">
        <div class="title ma-t-40">数智方舟的必要性</div>
        <div class="b-blue ma-t-10"></div>
      </div>
      <div class="c-333 t-center ma-tb-20">
        专注技术创新，坚持科技创造价值。
      </div>
      <div
        style="width: 1200px"
        class="flex f-between t-center theme2"
      >
        <div class="">
          <img src="../img/home/s21.png" />
          <div class="c-555 ma-t-20 width80 ma-lr-auto fon-14">
          智能技术加速赋能传统经济、新兴经济，并催生新的数字经济。人脸设别、语音识别、智能客服、客户行为分析、风险评估、精准营销等一度成为传统经济TOP应用。
          </div>
        </div>
        <div class="">
          <img src="../img/home/s22.png" />
          <div class="c-555 ma-t-20 width80 ma-lr-auto fon-14">
           To C企业在数字化转型中，企业可以借助数字化的用户运营手段，提升运营效率和消费者体验。
          </div>
        </div>
        <div class="">
          <img src="../img/home/s23.png" />
          <div class="c-555 ma-t-20 width80 ma-lr-auto fon-14">
           To B企业也需要进行数字化转型，向具有敏锐度的组织转型，并在组织、领导力、人才吸引、人才发展和人才激励等方面进行翻天覆地地变革。
          </div>
        </div>
      </div>
    </div>

    <!-- 讲师介绍 -->
    <div class="person">
      <div class="t-center flex f-center flex-direction fon-24 font-bold">
        <div class="fon-24 ma-t-50">服务亮点</div>
        <div class="b-009297 ma-t-10"></div>
      </div>

      <div class="width1200 flex f-around">
        <div>
          <div class="position">
            <img src="../img/home/s31.png" />
            <div class="ma-t-30 fon-18">分类教程</div>
            <div class="ma-t-10 fon-14">
             通过分门别类的行业细分内容进行精细化学习
            </div>
          </div>
        </div>
        <div>
          <div class="position">
            <img src="../img/home/s32.png" />
            <div class="ma-t-30 fon-18">授课形式</div>
            <div class="ma-t-10 fon-14">音频、视频、图文、案例分析、研究报告</div>
          </div>
        </div>
        <div>
          <div class="position">
            <img src="../img/home/s33.png" />
            <div class="ma-t-30 fon-18">传播价值</div>
            <div class="ma-t-10 fon-14">
             分享数智内容，传播数智资源
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<style lang="scss" scoped>
.theme2>div{
  width: 30%;
}
.height560{
  height: 560px !important;
}
.box-wrap{
  width: 30%;
  height: 230px;
  position: relative;
}
.img-bg{
  width: 100%;
  height: 100%;
  position:absolute;
  left: 0;
  top:0;
}
.box-hover{
  width:100%;
  height:100%;
  position:absolute;
  background: rgba(0, 0, 0, 0.521);
  color: #fff;
  opacity: 0;
  transition: all .3s ease-out;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-hover-b{
  width: 80%;
  height: 70%;
  border: 1px solid #fff;
  padding: 10px;
  
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-wrap:hover .box-hover{
  opacity: 1;
}
.lineheight28{
  line-height: 30px;
}
.width387 {
  width: 387px;
  height: 156px;
}
.img_60 {
  width: 60px;
  height: 60px;
}
.b-r {
  border-right: 1px #eee solid;
}
.b-b {
  border-bottom: 1px #eee solid;
}
.end_box {
  width: 553px;
  height: 232px;
}
.height400 {
  height: 400px !important;
}
.height600 {
  height: 600px !important;
  padding-bottom: 100px;
}
.height700 {
  height: 700px !important;
  padding-bottom: 100px;
}
.bg-e {
  background: #eeeeee !important;
}
.c-555 {
  color: #555;
}
.c-333 {
  color: #333333;
}
.ma-t-50 {
  margin-top: 50px;
}
.img_228 {
  width: 228px;
  height: 305px;
}
.width1200 {
  width: 1200px;

  margin: 90px auto;
}
.person {
  width: 100%;
  height: 539px;
  background-size: cover;
}
.position {
  width: 400px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  img {
    width: 90px;
    height: 90px;
  }
}

.height370 {
  height: 370px;
}
.width419 {
  width: 419px;
}
.home {
  min-width: 1200px;
  background: #fff;
  min-height: 500px;
  .bim {
    width: 100%;
    height: auto;
    // background-image: url(../img/mdmyy.png);
    // background-size: 100% 100%;
    background-repeat: repeat;
    position: relative;
    cursor: pointer;
    img {
      width: 100%;
      height: auto;
    }

    .toptexts {
      width: 580px;
      height: 157px;
      text-align: center;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      font-size: 20px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #000;
      opacity: 0.75;
      .weclome {
        color: #000;
        font-size: 45px;
        font-weight: bold;
        margin-bottom: 30px;
        font-weight: bold;
      }
      .texts {
        line-height: 30px;
        letter-spacing: 3px;
      }
    }
  }
  .swiper {
    width: 100%;
    height: 462px;
    position: relative;
    background-image: url(../img/home/b1.png);
    background-size: 100% auto;
    // background-position: 100% 100%;
    img {
      width: 100%;
      height: 484px;
    }
    .htop {
      width: 1200px;
      margin: 0 auto;
      // position: absolute;
      // top: 17%;
      // left: 50%;
      // transform: translateX(-600px);
    }
    .toptexts {
      width: 100%;
      height: 452px;
      // position: absolute;
      // top: 17%;
      // left: 12%;
      font-size: 24px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      // font-weight:bold;

      color: #fff;
      display: flex;
      justify-content: center;
      align-content: center;
      flex-direction: column;
      text-align: center;
      // line-height: 30px;
      .weclome {
        color: #fff;
        font-size: 16px;
        // font-weight: bold;
        margin-top: 30px;
        // font-weight: bold;
      }
    }
  }
}
.ma-b-0 {
  margin-bottom: 0px !important;
}
.ma-t-70 {
  margin-top: 70px;
}

.btn_green {
  width: 220px;
  height: 40px;
  background: #234775;
  border-radius: 20px;
  color: #fff;
}
.btn_white {
  width: 220px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #234775;
  border-radius: 20px;
  color: #234775;
}

.home .theme {
  background: #fff;
  margin: 40px auto;

  height: 555px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  .el-divider__text {
    font-weight: bold;
    color: rgba(15, 119, 191, 1);
  }
}
.home .theme .title {
  font-size: 24px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #000;
}
.b-blue {
  width: 200px;
  height: 3px;
  background: #009294;
}
.home .theme .classify {
  width: 362px;
  height: 147px;
  position: relative;
  padding: 30px 5%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.07);
  border-radius: 14px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.home .theme .classify .topic {
  display: flex;
  align-items: center;
  height: 21px;
  line-height: 21px;
  text-align: center;
  font-size: 16px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: rgba(15, 119, 191, 1);
}
.home .theme .classify .topic hr {
  width: 90px;
  height: 1px;
  line-height: 21px;
  color: #0f77bf;
  display: inline-block;
  border: 0px;
  background-color: #0f77bf;
}
.home .theme .classify .text {
  font-size: 12px;
  height: 48px;
  font-family: MicrosoftYaHei;
  color: rgba(15, 119, 191, 1);
}
.home .theme .classify .img-n {
  position: absolute;
  top: -20px;
  left: 5px;
  width: 53px;
  height: 48px;
}
.home .online {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0px;
  box-sizing: border-box;
  text-align: center;
  .more {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    margin: 0 auto;
    cursor: pointer;
    .icons {
      width: 20px;
      height: 20px;
      margin-top: 0;
      border-radius: 50%;
      border: 1px solid #0f77bf;
    }
    .more-text {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba(15, 119, 191, 1);
      margin-left: 10px;
    }
  }
}
.home .online .online-title {
  font-size: 24px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.home .online .online-type {
  width: 1200px;
  margin: 100px auto 0px auto;
  display: flex;
  justify-content: center;
}
.home .online .online-type .online-type-list {
  width: 25%;
  padding: 5px 0;
  margin-bottom: 70px;
  text-align: center;
  cursor: pointer;
  .type-img {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .type-title {
    margin-top: 25px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
  }
  .type-title:hover {
    color: #000000;
    font-weight: 600;
  }
}
.home .introduce {
  height: 28px;
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  margin-bottom: 16px;
}
.home .explain {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .st-title {
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}
.home .videos {
  width: 268px;
  margin-right: 30px;
  display: flex;
  justify-content: center;
  // padding: 5px 10px;
  box-sizing: border-box;
  cursor: pointer;
}
.home .tool-list {
  width: 350px;
  height: 95px;
  padding: 5px 0;
  margin-bottom: 70px;
  display: flex;
  justify-content: flex-start;
}
.width1140 {
  width: 80%;
  height: 425px;
}
.img_453 {
  width: 453px;
  height: 425px;
}
.c-blue {
  color: #234775;
}
.t-indent {
  // text-indent: 10px;
  line-height: 33px;
}
.b-009297 {
  width: 100px;
  height: 3px;
  background: #234775;
}
.three_box {
  width: 1200px;
  height: 700px;
  margin-top: 72px;
  .boxs {
    width: 263px;
    height: 352px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    position: relative;
    .img_263 {
      width: 263px;
      height: 220px;
    }
    .img_30 {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      top: 205px;
      left: 10px;
    }
  }
}
.ma-t-60 {
  margin-top: 60px !important;
}
.ma-t-10 {
  margin-top: 10px !important;
}
.four_box {
  width: 100%;
  height: 595px;
  background: #eeeeee;
  padding: 60px 0 0 0;
  .width1200 {
    width: 1200px;
    margin: 0 auto;
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .boxs {
      width: 549px;
      height: 165px;
      background: #fff;
      border-radius: 5px;
      margin-bottom: 20px;
      .img_230 {
        width: 230px;
        height: 137px;
      }
      .position {
        position: relative;
        .time {
          position: absolute;
          bottom: 30px;
        }
      }
    }
  }
}
.height302 {
  height: 302px !important;
}
.c-41 {
  color: #414141;
}
</style>
<script>
import {
  // Activitys,
  // HomeArticle,
  sign,

  // CategoryList,
  getIndexs,
} from "../api.js";
export default {
  name: "Home",
  components: {},
  data() {
    return {
      kinds: [], //学习资源种类列表
      newsList: [],
      activityList: [],
      play: false,
      name: "",
      phone: "",
      id: "",
      classList: [],
      detail: {},
      detail1: {},
      detail2: {},
    };
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);
    // 判断是否从详情页面回来

    next();
  },
  created() {
    // this.getNews();
    // this.getActivitys();
    // this.getClass();
    this.getIndex();
  },
  methods: {
    //获取首页数据
    getIndex() {
      getIndexs().then((res) => {
        this.detail = res.data.Data[0];
        this.detail1 = res.data.Data[1];
        this.detail2 = res.data.Data[2];
      });
    },

    toClassdetail(id = 1) {
      this.$router.push({
        path: "/Learn-detail",
        query: { id: id },
      });
    },
    plays(e) {
      this.$router.push({
        path: "/Activity",
        query: {
          id: e,
        },
      });
    },

    //更多课程
    moreClass() {
      this.$router.push({
        name: "Learn",
      });
    },

    //报名提交
    submit() {
      var that = this;
      var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;

      if (this.name == "") {
        this.$message.error("姓名不能为空哦！");
        return;
      }
      if (this.phone.length < 1) {
        this.$message.error("手机号不能为空哦！");
        return;
      } else if (!reg.test(this.phone)) {
        this.$message.error("手机格式不正确！");
        return;
      }

      let token = localStorage.getItem("AccessToken");
      let data = {
        Token: token,
        Name: this.name,
        Phone: this.phone,
        Id: this.id,
      };
      sign(data).then((res) => {
        console.log(res);
        if (res.data.Code == 0) {
          that.$message.success("报名成功");
          that.play = false;
        } else {
          that.$message({
            message: res.data.Message,
            type: "warning",
            center: true,
            customClass: "sps",
          });
        }
      });
    },

    toEnterprise() {
      this.$router.push({
        name: "About",
      });
    },

    //获取 星辰资讯
    // getNews() {
    //   HomeArticle().then((res) => {
    //     if (res.data.Code == 0) {
    //       this.newsList = res.data.Data;
    //     }
    //     console.log(res);
    //   });
    // },

    // getClass() {
    //   let token = localStorage.getItem("AccessToken");
    //   console.log(this.pageIndex);
    //   let data = {
    //     token: token,
    //     source: "web",
    //   };
    //   console.log(data);
    //   CategoryList(data).then((res) => {
    //     if (res.data.Code == 0) {
    //       this.classList = res.data.Data.List.slice(0, 3);
    //     }
    //   });
    // },

    //资讯详情
    toNews(id) {
      this.$router.push({
        path: "/Study-detail",
        query: { id: id },
      });
    },
    // getActivitys() {
    //   let data = {
    //     pagesize: 4,
    //     pageindex: 1,
    //   };
    //   Activitys(data).then((res) => {
    //     console.log(res);
    //     if (res.data.Code == 0) {
    //       this.activityList = res.data.Data.Data;
    //     }
    //   });
    // },
    // 更多资讯
    moreNews() {
      this.$router.push("/Resource");
    },

    //
    toActivity() {
      this.$router.push("/Practice");
    },
  },
};
</script>
